
import EoButton from '../EoButton/EoButton'

export default {
  name: 'EoApplication',
  components: {
    EoButton,
  },
  props: {
    /**
     * Style: background color of the whole application
     */
    color: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      spaceForFooter: 0,
      hasFooter: false,
      hasHeader: false,
      hasMain: false,
      pageTitle: null,
      screenReaderAnnouncement: null,
    }
  },
  computed: {
    classes () {
      return {
        'eo-application': true,
        ['color--' + this.color]: this.color,
      }
    },
  },
  watch: {
    $route: function (current, previous) {
      if (current.path === previous.path) { return }
      // Reset keyboard focus on route change
      this.$refs.focusReset?.focus()

      // Keep track of the page title
      setTimeout(() => {
        const metaTitle = this.$route.matched[0]?.instances.default?.$metaInfo?.title
        this.pageTitle = metaTitle || document.title || window.location.href
      }, 400)
    },
    pageTitle: function (title) {
      // Let screen reader know which page opened
      this.screenReaderAnnouncement = `Genavigeerd naar: ${title}`
    },
  },
  mounted () {
    // Make reference to this EoApplication available everywhere
    this.$library.application = this

    // Make focus reset element available everywhere
    this.$library.focusReset = this.$refs.focusReset
  },
}
